export default function Security() {
  return (
    <section id="security" className="py-40 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex gap-20 items-center">
          <div className="flex-1">
            <div className="inline-block px-4 py-2 bg-white/10 rounded-full mb-8">
              <span className="text-cyan-400 text-sm font-semibold tracking-wider uppercase">Security First</span>
            </div>
            
            <h2 className="text-7xl font-bold text-white mb-12 leading-tight">
              Your Privacy<br />
              is Our<br />
              Priority
            </h2>
            
            <p className="text-xl text-gray-400 leading-relaxed mb-16">
              We are committed to protecting your digital privacy with industry-leading encryption standards. 
              Our strict no-logs policy means we never collect, track, or store your browsing activity. 
              Your data belongs to you, and only you.
            </p>
            
            <div className="flex gap-6">
              <div className="px-6 py-4 bg-gray-800 rounded-2xl flex items-center gap-3">
                <i className="ri-lock-line text-cyan-400 text-2xl"></i>
                <span className="text-white font-semibold">AES-256 Encryption</span>
              </div>
              <div className="px-6 py-4 bg-gray-800 rounded-2xl flex items-center gap-3">
                <i className="ri-shield-check-line text-cyan-400 text-2xl"></i>
                <span className="text-white font-semibold">Zero Logs</span>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="h-[600px] rounded-[32px] bg-gradient-to-br from-blue-900 to-purple-900 relative overflow-hidden">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative">
                  <i className="ri-shield-keyhole-line text-cyan-400/40 text-[280px]"></i>
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <div className="w-32 h-32 bg-cyan-400/20 rounded-full animate-ping"></div>
                  </div>
                </div>
              </div>
              
              <div className="absolute top-10 left-10 px-4 py-2 bg-white/10 backdrop-blur-md rounded-lg border border-white/20">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                  <span className="text-white text-sm">Encrypted Connection</span>
                </div>
              </div>
              
              <div className="absolute bottom-10 right-10 px-4 py-2 bg-white/10 backdrop-blur-md rounded-lg border border-white/20">
                <div className="flex items-center gap-2">
                  <i className="ri-eye-off-line text-white"></i>
                  <span className="text-white text-sm">No Tracking</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}